import { Message } from "../../framework/src/Message";
import MessageEnum, { getName } from "../../framework/src/Messages/MessageEnum";
import { runEngine } from "../../framework/src/RunEngine";
import { verifyIcon, verifyOrange, verifyYellow } from "../../blocks/activityfeed/src/assests";
import { EventEmitter } from 'fbemitter'
import { createFFmpeg, fetchFile } from '@ffmpeg/ffmpeg';
import { CometChat } from "@cometchat/chat-sdk-javascript";
import { CometChatCalls } from "@cometchat/calls-sdk-javascript";
const baseURL = require("../../framework/src/config").baseURL;
import { toast } from 'react-toastify';
import { CometChatUIKit, UIKitSettingsBuilder } from "@cometchat/chat-uikit-react";
import { ApexOptions } from "apexcharts";

export type TAny = any;

export type TStatusStripeConnect = "created" | "pending" | "notCreated";

type HttpMethods = 'GET' | 'POST' | 'PUT' | 'PATCH' | 'DELETE'

interface RequestParams {
  method?: HttpMethods;
  headers?: object;
  body?: object | FormData | any;
}

const DEV_COMETCHAT_CONSTANTS = {
  APP_ID: "2679961c82e3c134",
  REGION: "in",
  AUTH_KEY: "1a030617482cec678e61699369c7cc6587f50291",
};
const COMETCHAT_CONSTANTS = {
  APP_ID: "267270c8cbb877e1",
  REGION: "us",
  AUTH_KEY: "5e48c5a9ad8ffcee83f8c87d8e3ff2476a804fe8",
};

export const getCredCometChat = () => {
  if (baseURL.includes("dev") || baseURL.includes("stage")) {
    return DEV_COMETCHAT_CONSTANTS
  }
  return COMETCHAT_CONSTANTS
}

export const loginCometChat = async (callbackSuccess?: TAny) => {
  const UIKitSettings = new UIKitSettingsBuilder()
    .setAppId(getCredCometChat().APP_ID)
    .setRegion(getCredCometChat().REGION)
    .setAuthKey(getCredCometChat().AUTH_KEY)
    .subscribePresenceForAllUsers()
    .build();

  try {
    let region = getCredCometChat().REGION;
    let appSetting = new CometChat.AppSettingsBuilder()
      .subscribePresenceForAllUsers()
      .setRegion(region)
      .autoEstablishSocketConnection(true)
      .build();
    await CometChat.init(getCredCometChat().APP_ID, appSetting)
    await CometChatUIKit.init(UIKitSettings);
    console.info("Initialization completed successfully");
  } catch (error) {
    console.error("Initialization failed with error: ", error);
  }
  try {
    await handleLoginCometChat(callbackSuccess);
  } catch (error) {
    console.error("Handle login comet chat failed with error: ", error)
  }
}

const handleLoginCometChat = async (callbackSuccess?: TAny) => {
  try {
    const cometChatToken = localStorage.getItem("cometChatToken") ?? ''
    const cometChatUid = cometChatToken.split('_')[0]
    await logoutCometChat();
    const user = await CometChatUIKit.login(cometChatUid);
    console.info("Login cometchat successfully with user: ", user);
    emitterEvents.emit(EMITTER_EVENT_VARIABLES.COMETCHAT_LOGGED_IN, true);
    callbackSuccess && callbackSuccess(user);
  } catch (error) {
    console.error("Login failed with error: ", error)
  }
}

export const logoutCometChat = async () => {
  const loggedUser = await CometChatUIKit.getLoggedinUser();
  if (loggedUser?.getAuthToken()) {
    try {
      await CometChatUIKit.logout();
      emitterEvents.emit(EMITTER_EVENT_VARIABLES.COMETCHAT_LOGOUT, true)
      console.info("Logout cometchat successfully")
    } catch (error) {
      console.error("Logout from Login screen failled with error: ", error)
    }
  }
}

export const formatDate = (date: Date) => {
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
  const year = date.getFullYear();
  return { validateDate: `${year}/${month}/${day}`, dobDate: `${day}/${month}/${year}` };
};

export function sendAPIRequest(endpoint: string, params?: RequestParams) {

  const { method = "GET", headers, body } = params || {}
  const requestMessage = new Message(
    getName(MessageEnum.RestAPIRequestMessage)
  )
  const callId = requestMessage.messageId
  requestMessage.addData(
    getName(MessageEnum.RestAPIResponceEndPointMessage),
    endpoint
  )
  requestMessage.addData(
    getName(MessageEnum.RestAPIRequestMethodMessage),
    method
  )
  if (body)
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestBodyMessage),
      body?.append ? body : JSON.stringify(body)
    )

  if (headers)
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestHeaderMessage),
      headers
    )
  runEngine.sendMessage(requestMessage.id, requestMessage)
  return callId
}

export const convertMentionHashtagText = (input: string): string => {
  return input.replace(/@\*(.*?)\*|\@\[(#.*?)\]\(\d+\)/g, (match: string, p1: string, p2: string) => {
    if (p1 !== undefined) {
      return `${p1}`; // Convert @*mention* to @mention
    } else if (p2 !== undefined) {
      return p2; // Convert @[#hash_tag](5) to #hash_tag
    }
    return match; // Return the original match if no condition is met
  });
}

export const downloadGifFromUrl = async (gifUrl: string, gifName: string) => {
  try {
    const response = await fetch(gifUrl);
    const blob = await response.blob();
    const file = new File([blob], gifName, { type: 'image/gif' });
    return file
  } catch (error) {
    console.error('Error downloading GIF', error);
  }
};

export const removeStorageData = async (key: string) => {
  try {
    localStorage.removeItem(key);
    console.log(`Removed item with key: ${key}`);
  } catch (error) {
    console.error(`Error removing item with key: ${key}`, error);
  }
};

export const highlightText = (body: any, highlights: any) => {
  const combinedHighlights = [...highlights].sort((a, b) => a.indices[0] - b.indices[0]);

  let highlightedBody = '';
  let currentIndex = 0;

  combinedHighlights.forEach(highlight => {
    const start = highlight.indices[0];
    const end = highlight.indices[1];

    highlightedBody += body.substring(currentIndex, start);

    highlightedBody += `<span style="color: ${"#8429Ef"};" >${body.substring(start, end)}</span>`;
    currentIndex = end;
  });

  highlightedBody += body.substring(currentIndex);

  const urlRegex = /(https?:\/\/[^\s]+)/g;
  const outputString = highlightedBody.replace(urlRegex, (url) => {
    return `<a href=${url} target="_blank" style="color: ${"#8429Ef"};">${url}</a>`;
  });

  return outputString;
};

export const getBorderRadiusClass = (index: number, length: number, classes: any) => {
  if (length === 1) return classes.borderRadius;
  const borderClasses = [];
  if (index === 0) borderClasses.push(classes.topLeftRadius);
  if (index === 1) {
    if (length === 2) {
      borderClasses.push(classes.topRightRadius, classes.bottomRightRadius);
    } else {
      borderClasses.push(classes.topRightRadius);
    }
  }
  if (index === length - 2) {
    if (length === 3) {
      borderClasses.push(classes.bottomRightRadius);
    } else {
      borderClasses.push(classes.bottomLeftRadius);
    }
  }
  if (index === length - 1) {
    if (length === 3) {
      borderClasses.push(classes.bottomLeftRadius);
    } else {
      borderClasses.push(classes.bottomRightRadius);
    }
  }
  return borderClasses.join(' ');
};

export const verifyImg = (userSubscription: string) => {
  switch (userSubscription) {
    case 'I am a business':
      return verifyYellow
    case 'I am a news organization':
      return verifyOrange
    default:
      return verifyIcon
  }
}

export function convertTimestampToTime(timestamp: number): string {
  const date = new Date(timestamp * 1000);
  const hours: string = date.getUTCHours().toString().padStart(2, '0');
  const minutes: string = date.getUTCMinutes().toString().padStart(2, '0');

  return `${hours}:${minutes}`;
}

export const handleConditionFunction = (condition: TAny, trueCondition: TAny, falseCondtion: TAny) => {
  return condition ? trueCondition : falseCondtion
}

export const emitterEvents = new EventEmitter()

export enum EMITTER_EVENT_VARIABLES {
  COMETCHAT_LOGGED_IN = "cometChatLoggedIn",
  START_CALL_SESSION = "startCallSession",
  RESET_CALL = "resetCall",
  MESSAGE_ID_REACTION = "messageIdReaction",
  INCOMING_CALL = "incomingCall",
  ACCEPT_CALL = "acceptCall",
  REJECT_CALL = "rejectCall",
  CLOSE_MODAL_CALL = "closeModalCall",
  CANCEL_CALL = "cancelCall",
  CURRENT_CALL = "currentCall",
  IS_CALLING = "isCalling",
  COMETCHAT_LOGOUT = "cometChatLogOut",
}

interface Location {
  latitude: number | null;
  longitude: number | null;
}

export const getLocation = (): Promise<Location | null> => {
  return new Promise((resolve, reject) => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          resolve({
            latitude: position.coords.latitude,
            longitude: position.coords.longitude,
          });
        },
        (error) => {
          console.warn(error.message);
          reject(error.message);
        }
      );
    } else {
      reject('Geolocation is not supported by this browser.');
    }
  });
};

export const scrollIntoElement = (refElement: any, elementDom: string) => {
  if (refElement) {
    if (!refElement?.querySelectorAll) return;
    const elements = refElement.querySelectorAll(elementDom);
    if (!elements.length) return;
    elements[0].scrollTop = (elements[0].scrollHeight)
  }
}

const createBulkUpLoading = async () => {
  const url = `${baseURL}/bx_block_bulk_uploading/attachments`

  const response = await fetch(url, {
    method: 'POST',
    headers: {
      token: localStorage.getItem('authToken') || ''
    },
  });

  if (!response.ok) {
    throw new Error(`HTTP error! Status: ${response.status}`);
  }

  const responseData = await response.json()

  return responseData?.data?.id
}

const uploadChunk = async (file: Blob, attachmentId: string, id: number) => {
  const formData = new FormData();
  formData.append('id', String(attachmentId));
  formData.append('chunk_number', id.toString());
  formData.append('chunk', file);

  const url = `${baseURL}/bx_block_bulk_uploading/attachments/${attachmentId}/upload_chunk`

  const response = await fetch(url, {
    method: 'POST',
    headers: {
      token: localStorage.getItem('authToken') || ''
    },
    body: formData
  });

  if (!response.ok) {
    throw new Error(`HTTP error! Status: ${response.status}`);
  }
}

const finalizeUpload = async (attachmentId: string) => {
  const url = `${baseURL}/bx_block_bulk_uploading/attachments/${attachmentId}/finalize_upload`

  const response = await fetch(url, {
    method: 'POST',
    headers: {
      token: localStorage.getItem('authToken') || ''
    },
    body: JSON.stringify({
      id: attachmentId
    })
  });

  if (!response.ok) {
    throw new Error(`HTTP error! Status: ${response.status}`);
  }

  const responseData = await response.json()
  return responseData?.success
}

export const chunkVideoFFmpeg = async (videoFile: File) => {
  const ffmpeg = createFFmpeg({
    log: true,
    mainName: 'main',
    corePath: 'https://unpkg.com/@ffmpeg/core-st@0.11.1/dist/ffmpeg-core.js',
  });

  const chunkTime = '20' // 20s
  let toastId: string | number = ''
  const styles = {
    backgroundColor: '#222',
    color: '#FFF',
  }

  try {
    if (!ffmpeg.isLoaded()) {
      await ffmpeg.load();
    }

    if (!videoFile) return;

    const extension = videoFile.name.split('.').pop()?.toLowerCase()
    toastId = toast.loading('Processing video...', {
      style: styles,
    });

    await ffmpeg.FS('writeFile', `input.${extension}`, await fetchFile(videoFile));

    await ffmpeg.run(
      '-i',
      `input.${extension}`,
      '-c',
      'copy',
      '-map',
      '0',
      '-segment_time',
      chunkTime,
      '-f',
      'segment',
      `output%05d.${extension}`,
    );

    const chunkFiles: Blob[] = []

    let i = 0;
    while (true) {
      try {
        // Read chunk file from FFmpeg's virtual file system
        const chunkData = await ffmpeg.FS('readFile', `output${String(i).padStart(5, '0')}.${extension}`);
        const chunkBlob = new Blob([chunkData.buffer], { type: videoFile.type });
        chunkFiles.push(chunkBlob);
        await ffmpeg.FS('unlink', `output${String(i).padStart(5, '0')}.${extension}`)
        i++;
      } catch (error) {
        // Break the loop if there is no more chunk to read (file not found)
        break;
      }
    }

    await ffmpeg.FS('unlink', `input.${extension}`)

    const attachmentId: string = await createBulkUpLoading()

    for (let chunkIndex = 0; chunkIndex < chunkFiles.length; chunkIndex++) {
      const chunkFile = chunkFiles[chunkIndex];
      await uploadChunk(chunkFile, attachmentId, chunkIndex);
    }
    
    const isSuccess = await finalizeUpload(attachmentId)
    if (isSuccess) {
      toast.update(toastId, {
        render: `Uploaded file`,
        type: "info",
        autoClose: 3000,
        isLoading: false,
        style: styles,
      });
      return attachmentId
    } else {
      throw new Error('Upload failed')
    }
  } catch (err) {
    if (toastId) {
      toast.update(toastId, {
        render: `Upload failed`,
        type: "error",
        autoClose: 3000,
        isLoading: false,
        style: styles,
      });
    } else {
      toast.error(`Upload failed`, {
        autoClose: 3000,
        style: styles,
      });
    }
    console.log('Load FFmpeg Error', err)
  }
}

export const generateTokenCall = async (sessionID: string) => {
  const loggedInUser = await CometChat.getLoggedinUser();
  let token = "";
  if (loggedInUser) {
    const authToken = loggedInUser.getAuthToken();

    const { token } = await CometChatCalls.generateToken(sessionID, authToken);
    return token;
  }
  return token;
}

export const joinCallSession = async (tokenSession: string, sessionId: string) => {
  const defaultLayout = true;
  const audioOnly = true;
  const pauseVideoButton = false;
  const showScreenShareButton = false;
  const showSwitchToVideoCallButton = false;

  let isValidCallSession = true;
  try {
    await CometChatCalls.getCallDetails(sessionId, localStorage.getItem("cometChatToken") ?? "");
  } catch (error) {
    console.error("Get call detailed failed with error: ", error)
    isValidCallSession = false;
  }

  const callSettings = new CometChatCalls.CallSettingsBuilder()
    .enableDefaultLayout(defaultLayout)
    .setIsAudioOnlyCall(audioOnly)
    .showPauseVideoButton(pauseVideoButton)
    .showScreenShareButton(showScreenShareButton)
    .showSwitchToVideoCallButton(showSwitchToVideoCallButton)
    .setMode(CometChat.CALL_MODE.TILE as "TILE")
    .setCallListener(
      new CometChatCalls.OngoingCallListener({
        onUserListUpdated: (userList) => {
          console.log("user list:", userList);
        },
        onCallEndButtonPressed() {
          console.info("On call end button pressed ", isValidCallSession)
          if (!isValidCallSession) {
            emitterEvents.emit(EMITTER_EVENT_VARIABLES.RESET_CALL);
            return;
          }
        },
        onCallEnded: async () => {
          console.log("On Call Ended");
          emitterEvents.emit(EMITTER_EVENT_VARIABLES.RESET_CALL);
        },
        onError: (error) => {
          console.log("Error :", error);
        },
        onMediaDeviceListUpdated: (deviceList) => {
          console.log("Device List:", deviceList);
        },
        onUserMuted: (event) => {
          // This event will work in JS SDK v3.0.2-beta1 & later.
          console.log("Listener => onUserMuted:", {
            userMuted: event.muted,
            userMutedBy: event.mutedBy,
          });
        },
        onUserJoined: (user) => console.log("event => onUserJoined", user),
        onUserLeft: (user) => console.log("event => onUserLeft", user),
      })
    )
    .build();

  const htmlElement = document.getElementById("callContainer") as HTMLElement;
  try {
    const call = await CometChat.acceptCall(sessionId);
    emitterEvents.emit(EMITTER_EVENT_VARIABLES.ACCEPT_CALL, call, tokenSession)
    console.info("Accept call session successfully: ", sessionId);
  } catch (error) {
    console.error("Accept call session failed with error: ", error);
  }
  try {
    await CometChatCalls.startSession(tokenSession, callSettings, htmlElement);
    console.info("Start call session successfully: ", sessionId);
  } catch (error) {
    console.error("Start call session failed with error: ", error);
  }
}

export const startCallSession = async (tokenSession: string, call: CometChat.Call) => {
  const defaultLayout = true;
  const audioOnly = true;
  const pauseVideoButton = false;
  const showScreenShareButton = false;
  const showSwitchToVideoCallButton = false;

  emitterEvents.emit(EMITTER_EVENT_VARIABLES.ACCEPT_CALL, call, tokenSession);
  const callSettings = new CometChatCalls.CallSettingsBuilder()
    .enableDefaultLayout(defaultLayout)
    .setIsAudioOnlyCall(audioOnly)
    .showPauseVideoButton(pauseVideoButton)
    .showScreenShareButton(showScreenShareButton)
    .showSwitchToVideoCallButton(showSwitchToVideoCallButton)
    .setMode(CometChat.CALL_MODE.TILE as "TILE")
    .setCallListener(
      new CometChatCalls.OngoingCallListener({
        onUserListUpdated: (userList) => {
          console.log("user list:", userList);
        },
        onCallEndButtonPressed: async () => {
          console.log("End Call button pressed");
          await CometChat.endCall(call?.getSessionId())
        },
        onCallEnded: async () => {
          console.log("On Call Ended");
          emitterEvents.emit(EMITTER_EVENT_VARIABLES.RESET_CALL);
        },
        onError: (error) => {
          console.log("Error :", error);
        },
        onMediaDeviceListUpdated: (deviceList) => {
          console.log("Device List:", deviceList);
        },
        onUserMuted: (event) => {
          // This event will work in JS SDK v3.0.2-beta1 & later.
          console.log("Listener => onUserMuted:", {
            userMuted: event.muted,
            userMutedBy: event.mutedBy,
          });
        },
        onUserJoined: (user) => console.log("event => onUserJoined", user),
        onUserLeft: (user) => console.log("event => onUserLeft", user),
      })
    )
    .build();

  const htmlElement = document.getElementById("callContainer") as HTMLElement;
  try {
    await CometChatCalls.startSession(tokenSession, callSettings, htmlElement);
    console.info("Start call session successfully: ", call);
  } catch (error) {
    console.error("Start call session failed with error: ", error);
    emitterEvents.emit(EMITTER_EVENT_VARIABLES.RESET_CALL)
  }
}

export const validateNumberField = (value: string) => {
  if (value === '') {
    return value; // Allow empty string
  }

  const hasOnlyDigitsAndDot = /^[0-9.]+$/.test(value);
  const hasAtMostOneDot = (value.match(/\./g) || []).length <= 1;

  if (hasOnlyDigitsAndDot && hasAtMostOneDot) {
    const numberValue = parseFloat(value);
    if (!isNaN(numberValue) && numberValue >= 0) {
      return value;
    }
  }

  return undefined;
};

export const barChartOptions: ApexOptions = {
  chart: {
      type: 'bar',
      background: 'transparent',
      toolbar: { show: false },
  },
  plotOptions: {
      bar: {
          borderRadius: 4,
          columnWidth: '45px',
      },
  },
  dataLabels: {
      enabled: false,
  },
  fill: {
      type: 'gradient',
      gradient: {
          shade: 'dark',
          type: 'vertical',
          shadeIntensity: 0.7,
          gradientToColors: ['#DA22FF'], // end color
          inverseColors: false,
          opacityFrom: 1,
          opacityTo: 1,
          stops: [0, 100],
      },
  },
  colors: ['#3A0CA3'], // start color
  grid: {
      borderColor: '#444',
      strokeDashArray: 4,
  },
  xaxis: {
      categories: ['Jan', 'Feb', 'March', 'April', 'May', 'June', 'July'],
      labels: {
          style: {
              colors: '#FFFFFF',
              fontSize: '10px',
              fontFamily: 'Manrope',
              fontWeight: 500,
          },
      },
  },
  yaxis: {
      labels: {
          style: {
              colors: '#FFFFFF',
              fontSize: '10px',
              fontFamily: 'Manrope',
              fontWeight: 500,
          },
          formatter: (val) => val.toLocaleString(),
      },
  },
  tooltip: {
      theme: 'dark',
  },
};

interface graphDataRetrunType {
  options: ApexOptions;
  series: ApexAxisChartSeries;
}

export const prepareGraphData = (list: { month: string; count: number; }[], isChecked: boolean): graphDataRetrunType => {
  const seriesData = list.map((item) => item.count ?? 0);
  const categoriesList = list.map((item) => item.month.toUpperCase());

  const series = [{
    name: 'Revenue',
    data: [...seriesData],
  }];

  const updatedOptions = {
    ...barChartOptions,
    xaxis: {
      categories: categoriesList,
      labels: {
        ...barChartOptions.xaxis?.labels,
        style: {
          ...barChartOptions.xaxis?.labels?.style,
          colors: Array(categoriesList.length).fill(isChecked ? "#222222" : '#FFF'),
        },
      },
    },
  };
  return { options: updatedOptions, series };
}